export enum CalculatedColumnOperator {
  SUM = '+',
  SUBTRACT = '-',
  MULTIPLY = '*',
  DIVIDE = '/',
  PERCENT = '%',
}
